import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { CoreInjectorTokens, UserRole } from '@fleet-beat/core';
import { AuthService } from '@fleet-beat/shared';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
  constructor(
    @Inject(CoreInjectorTokens.LoginUrl) private defaultUrl: string,
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userType: string = localStorage.getItem('fb-userTypeLogOut');
    if (!this.authService.authenticated) {
      if (userType === UserRole.Admin) {
        this.router.navigate([this.defaultUrl + '/admin'], { state: { returnUrl: state.url } }).then();
      } else {
        this.router.navigate([this.defaultUrl], { state: { returnUrl: state.url } }).then();
      }

      return false;
    }
    return true;
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  canLoad(route: Route, segments: UrlSegment[]): boolean {
    if (!this.authService.authenticated) {
      this.router.navigate([this.defaultUrl]).then();
      return false;
    }
    return true;
  }
}
